import { createV3Queries } from "@query/utils/createV3Queries";
import { requirementsApi } from "@api";

export const queriesRequirements = createV3Queries(
  "requirementsApi",
  requirementsApi
);
